import styled from 'styled-components/native';

export const SectionContainer = styled.View``;

export const SectionTitle = styled.View`
  padding: 0px 10px 16px 10px;
`;
